export class GroupModel {
    public groupId: number = -99;
    public groupHeading: string = '';
    public groupHeadingEn: string = '';
    public groupHeadingFr: string = '';
    public groupSubHeading: string = '';
    public groupSubHeadingEn: string = '';
    public groupSubHeadingFr: string = '';
}